/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_SubInputs */

const en_mk_faq_sub = /** @type {(inputs: Mk_Faq_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers to help you choose how to work.`)
};

const id_mk_faq_sub = /** @type {(inputs: Mk_Faq_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jawaban untuk memilih cara kerja yang tepat.`)
};

/**
* | output |
* | --- |
* | "Answers to help you choose how to work." |
*
* @param {Mk_Faq_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_sub = /** @type {((inputs?: Mk_Faq_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_sub(inputs)
	return en_mk_faq_sub(inputs)
});